import {
    LOGOUT,
    OTP_FAIELD,
    AUTH_FAILED,
    USER_LOADED,
    USER_EDITED,
    USER_FAILED,
    AUTH_LOADING,
    OTP_VERIFIED,
    LOGIN_FAILED,
    RESET_STATUS,
    OAUTH_DEVICE_CLEARED,
    PASSWORD_CHANGED,
    LOGIN_SUCCESSFUL,
    RESETTING_PASSWORD,
    REGISTRATION_FAILED,
    REGISTRATION_LOADING,
    REGISTRATION_COMPLETED,
    REGISTRATION_SUCCESSFUL,
    RESET_PASSWORD_SUCCESS,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAILED,
    OAUTH_REGISTER_FAILED,
    OAUTH_REGISTER_SUCCESS,
    OAUTH_REGISTER_RESET,
} from "../types";

const initialState = {
    user: null,
    isOTP: false,
    profile: null,
    message: null,
    parentCompany: null,
    balance: 0,
    isUser: localStorage.getItem("isUser") === "isUser",
    isCompany: localStorage.getItem("isCompany") === "isCompany",
    isCp: false,
    loading: false,
    isAuthenticated: false,
    token: localStorage.getItem("NanObOxAUTHTOKEN"),
    tokenPresent:
        localStorage.getItem("NanObOxAUTHTOKEN") !== null &&
        localStorage.getItem("NanObOxAUTHTOKEN") !== undefined,
    success: false,
    successPayload: null,
    oAuthRegistered: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case REGISTRATION_LOADING:
        case RESETTING_PASSWORD:
        case AUTH_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
                message: null,
                successPayload: null,
            };

        case OAUTH_DEVICE_CLEARED:
            return {
                ...state,
                loading: false,
            };
        case OAUTH_REGISTER_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false,
                message: null,
                oAuthRegistered: true,
            };
        case OAUTH_REGISTER_RESET:
        case OAUTH_REGISTER_FAILED:
            return {
                ...state,
                loading: false,
                oAuthRegistered: false,
                message: action.payload,
            };

        case USER_LOADED:
        case OTP_VERIFIED:
        case LOGIN_SUCCESSFUL:
            if (action.payload.token) {
                localStorage.setItem("NanObOxAUTHTOKEN", action.payload.token);
            }
            localStorage.setItem("isUser", action.payload.isUser ? "isUser" : null);

            if (action.payload.isCompany)
                localStorage.setItem("isCompany", "isCompany");

            return {
                ...state,
                ...action.payload,
                loading: false,
                tokenPresent: action.payload.token !== null,
                isAuthenticated: action.payload.token !== null,
                isCp:
                    action.payload.isCompany &&
                    action.payload.parentCompany !== null &&
                    action.payload.parentCompany !== undefined,
            };
        case USER_EDITED:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case PASSWORD_CHANGED:
            return {
                ...state,
                success: true,
                loading: false,
            };
        case REGISTRATION_COMPLETED:
        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                success: true,
                loading: false,
                tokenPresent: false,
                isAuthenticated: false,
            };
        case OTP_FAIELD:
        case RESET_STATUS:
        case USER_FAILED:
            return {
                ...state,
                success: false,
                loading: false,
            };
        case LOGOUT:
        case AUTH_FAILED:
        case LOGIN_FAILED:
        case REGISTRATION_FAILED:
        case PASSWORD_RESET_FAILED:
        case PASSWORD_RESET_SUCCESS:
        case REGISTRATION_SUCCESSFUL:
            localStorage.removeItem("NanObOxAUTHTOKEN");
            localStorage.removeItem("isCompany");
            localStorage.removeItem("isUser");
            return {
                ...initialState,
                token: null,
                isUser: false,
                loading: false,
                success: false,
                isCompany: false,
                tokenPresent: false,
                isAuthenticated: false,
            };
        default:
            return state;
    }
}
